export const PreTestIcon = () => {
  return (
    <span style={{ marginRight: 5 }}>
      <svg
        id="Grupo_4802"
        data-name="Grupo 4802"
        xmlns="http://www.w3.org/2000/svg"
        width="13.455"
        height="13.455"
        viewBox="0 0 13.455 13.455"
      >
        <path
          id="Caminho_3758"
          data-name="Caminho 3758"
          d="M0,0H13.455V13.455H0Z"
          fill="none"
          stroke="#000"
          stroke-width="0"
        />
        <path
          id="Caminho_3759"
          data-name="Caminho 3759"
          d="M12.091,3H3.121A1.125,1.125,0,0,0,2,4.121V11.97a1.125,1.125,0,0,0,1.121,1.121h8.97a1.125,1.125,0,0,0,1.121-1.121V4.121A1.125,1.125,0,0,0,12.091,3ZM6.485,10.849h-2.8V9.727h2.8Zm0-2.242h-2.8V7.485h2.8Zm0-2.242h-2.8V5.242h2.8Zm2.7,3.364L7.606,8.135l.79-.79.79.8,1.777-1.777.8.8Z"
          transform="translate(-0.879 -1.318)"
          fill="#6B48FF"
          stroke="#000"
          stroke-width="0"
          fill-rule="evenodd"
        />
      </svg>
    </span>
  );
};
